import React from 'react';
import './index.css';
import App from './app';
import * as serviceWorker from './serviceWorker';
import RootPortalRef from './constants/RootPortalRef';

import { createRoot } from 'react-dom/client';

const root = createRoot(document.getElementById('root'));

root.render(
    <React.Fragment>
            <App/>
        <div ref={RootPortalRef}/>
    </React.Fragment>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
